<template>
    <div class="footer-component-container">

        <div class="link-box">
            <div class="container-content">

                <div class="about-content">
                    <p class="title">关于米莫</p>
                    <ul>
                        <li><router-link to="/about">关于我们</router-link></li>
                        <li><router-link to="/whyus">为什么选择米莫印品？</router-link></li>
                        <li><router-link to="/comment">客户评价</router-link></li>
                    </ul>
                </div>
                <div class="help-content">
                    <p class="title">帮助中心</p>
                    <ul>
                        <li><a target="_blank" href="http://www.v5kf.com/public/help?sid=114994">常见问题</a></li>
                        <li><a target="_blank" href="http://100001196622.im.n.weimob.com">点击在线咨询</a></li>
                        <li>客服热线：17620737763</li>
                        <li>法定工作日 9:30-18:00</li>
                    </ul>
                </div>
                <div class="qrcode-content">
                    <div class="qrcode-item">
                        <img src="//cdn1.mimoprint.com/c-website/image/front/newpublic.png">
                        <p>微信公众号</p>
                    </div>
                    <!-- <div class="qrcode-item">
                        <img src="//cdn1.mimoprint.com/c-website/image/front/kcat.jpg">
                        <p>代理加盟</p>
                    </div> -->
                </div>
                <a class="b-content" href="https://www.mimoprint.vip/">
                    <p class="title">摄影师合作</p>

                    <img src="//cdn1.mimoprint.com/c-website/image/front/footerIcon.jpg">
                </a>

            </div>
        </div>

        <div class="copyright-box">
            Copyright 2013-2020 版权所有 广州云乐数码科技有限公司 <a>粤ICP备09190341</a>
        </div>

    </div>
</template>

<script>
export default {
    name: "",

    data() {
        return {};
    },

    computed: {},

    methods: {},

    created() {},
    mounted() {}
};
</script>

<style lang="less" scoped>
.footer-component-container{
    border-top: 1px solid #ddd;
    box-sizing: border-box;

    .link-box{
        .container-content{
            width: 1200px;
            margin: 0 auto;

            display: flex;
            padding-top: 30px;
            padding-bottom: 40px;

            .title{
                font-size: 20px;
                color: #666666;
                margin-bottom: 25px;
            }

            ul,
            a{
                color: #999;
                font-size: 14px;
                line-height: 2;
            }

            .about-content,
            .help-content{
                width: 300px;
            }

            .qrcode-content{
                font-size: 0;

                display: flex;
                justify-content: space-around;
                text-align: center;
                align-items: center;
                width: 260px;
                img{
                    width: 96px;
                }
                p{
                    font-size: 14px;
                    color: #666;
                }
            }
            .b-content{
                margin-left: 110px;
            }
        }
    }

    .copyright-box{
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #333333;
        font-size: 14px;

        border-top: 1px solid #ddd;
        box-sizing: border-box;
    }
}
</style>